<template>
  <el-card class="box-card connect-services">
    <div class="module-card-header">
      <span
        class="connect-services-content-item-badge"
        :class="
          service.is_active
            ? 'badge-success'
            : service.is_deactivated
            ? 'badge-danger'
            : 'badge-default'
        "
      >
        <i class="fa fa-check" v-if="service.is_active"></i>
        <i class="fa fa-ban" v-else></i>
      </span>

      <div class="service-inner">
        <div class="service-inner-image">
          <img :src="service.logo" alt="Service Image" />
        </div>
        <div class="service-inner-info">
          <h3>{{ service.name }}</h3>
          <p>{{ service.description }}</p>
        </div>
      </div>

    </div>
    <div v-if="loading" class="overlay">
      <i class="el-icon-loading"></i>
      <!-- loader element-ui -->
    </div>
    <div v-else class="card-content">
      <!-- Déjà actif -->
      <div v-if="service.is_active" class="activated">
        <span class="text-success"><i class="el-icon-check"></i> {{ $t("ELIXIO_CONNECT.ACTIVE") }}</span>
        <el-button class="ml-3" type="text" @click="toggleConfig"
          ><i class="el-icon-setting"></i> {{ $t("ELIXIO_CONNECT.CONFIGURE") }}</el-button
        >
      </div>

      <!-- Bouton Activer -->
      <div v-else>
        <el-button class="ml-3" type="text" @click="toggleConfig"
          ><i class="el-icon-open"></i> {{ $t("ELIXIO_CONNECT.ACTIVATE") }}</el-button
        >
      </div>

      <!-- Configurations -->
      <div v-if="showConfig" class="form-wrapper full mt-3">
        <module-credential-editor
          :service="service"
          :organization="currentOrganization"
          @onSubmited="handleFormSubmited"
          @onCancelled="handleFormCancelled"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import { cloneDeep } from "lodash";
import { Card, Button, Tabs, TabPane } from "element-ui";
import ModuleCredentialEditor from "./ModuleCredentialEditor.vue";

export default {
  name: "ModuleCard",

  components: {
    [Button.name]: Button,
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    ModuleCredentialEditor,
  },

  props: ["action", "service", "organization", "refreshingServiceId"],

  data() {
    const serviceData = cloneDeep(this.service ?? emptyService);
    const currentOrganization = cloneDeep(this.organization);

    return {
      showConfig: false,
      serviceData,
      currentOrganization,
      loading: this.refreshingServiceId === this.service.id,
    };
  },

  computed: {},

  created() {},

  methods: {
    handleFormSubmited({ success, service }) {
      this.$emit("onSubmited", { success, service });
    },
    handleFormCancelled() {
      this.showConfig = false;
      this.$emit("onClosed");
    },
    toggleConfig() {
      this.showConfig = !this.showConfig;
    },
  },

  mounted() {},

  watch: {
    service(newValue) {
      this.serviceData = cloneDeep(newValue ?? emptyService);
    },
    organization(newValue) {
      this.currentOrganization = cloneDeep(newValue);
    },
    refreshingServiceId(newValue) {
      this.loading = newValue === this.service.id;
      console.log(
        `ModuleCard - Service ID: ${this.service.id}, refreshingServiceId changed:`,
        newValue,
        "=> loading:",
        this.loading
      );
    },
  },
};
</script>

<style lang="scss">
.service-configuration {
  width: 100%;
  display: flex;
  flex-direction: column;
  &-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    h3 {
      width: auto !important;
      font-size: 20px;
      line-height: 24px;
      color: var(--tertiary);
    }
    a {
      width: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      min-height: 40px;
      border-radius: 8px;
      background-color: var(--primary);
      border: solid 1px var(--primary);
      margin: 0;
      padding: 0 20px;
      color: #fff;
      font-family: "Greycliff CF Bold", sans-serif;
      -webkit-transition: all 0.3s ease-in-out;
      -moz-transition: all 0.3s ease-in-out;
      transition: all 0.3s ease-in-out;
      &:hover {
        background-color: var(--darken-primary);
      }
    }
  }
  &-content {
    width: 100%;
    margin: 20px 0 0 0;
    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav-wrap {
          &:after {
            display: none;
          }
          .el-tabs__nav {
            background-color: #f5f6ec;
            border-radius: 8px;
            min-height: 41px;
            padding: 4px;
            .el-tabs__active-bar {
              display: none;
            }
            .el-tabs__item {
              border-radius: 8px;
              color: var(--tertiary);
              font-family: "Greycliff CF Medium", sans-serif;
              &.is-active {
                background-color: #fff;
                box-shadow: 0px 2px 3px 0px #0000000f;
                font-family: "Greycliff CF Bold", sans-serif;
              }
            }
          }
        }
      }
      .el-tabs__content {
        margin: 20px 0 0 0;
        .container {
          padding: 0;
          h5 {
            font-size: 20px;
            margin: 0 0 20px 0;
          }
        }
      }
    }
  }
}
.connect-services {
  width: 100%;
  display: flex;
  flex-direction: column;
  &-title {
    width: 100%;
    font-size: 24px;
    line-height: 30px;
  }
  &-content {
    width: 100%;
    margin: 20px 0 0 0 !important;
    display: flex;
    flex-direction: row;
    &-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin: 0 0 16px 0;
      box-shadow: 0px 2px 4px 0px #0000001f;
      box-shadow: 0px 0px 4px 0px #0000001f;
      border-radius: 16px;
      position: relative;
      padding: 0 !important;
      &-badge {
        position: absolute;
        top: 10px;
        right: 30px;
        width: 24px;
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        &.badge-default {
          background-color: var(--primary);
        }
        i {
          font-size: 12px;
        }
      }
      .service-inner {
        width: 100%;
        display: flex;
        flex-direction: row;
        &-image {
          width: 140px;
          height: 140px;
          background-color: #fff;
          display: flex;
          flex-direction: 100%;
          border-radius: 16px;
          padding: 12px 0 12px 12px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 10px;
          }
        }
        &-info {
          width: calc(100% - 200px);
          padding: 12px 16px;
          display: flex;
          flex-direction: column;
          h3 {
            font-size: 20px;
            line-height: 24px;
            color: var(--tertiary);
          }
          p {
            font-size: 16px;
            color: #6b7280;
            margin: 12px 0 0 0;
          }
          &-buttons {
            width: 100%;
            margin: 0;
            display: flex;
            flex-direction: row;
            margin: 12px 0 0 0;
            a {
              width: auto;
              display: flex;
              flex-direction: row;
              align-items: center;
              min-height: 40px;
              border-radius: 8px;
              background-color: var(--primary);
              border: solid 1px var(--primary);
              margin: 0 10px 0 0;
              padding: 0 20px;
              color: #fff;
              font-family: "Greycliff CF Bold", sans-serif;
              -webkit-transition: all 0.3s ease-in-out;
              -moz-transition: all 0.3s ease-in-out;
              transition: all 0.3s ease-in-out;
              &:last-child {
                margin: 0;
              }
              &:hover {
                background-color: var(--darken-primary);
              }
              &:nth-child(2) {
                background-color: transparent;
                color: var(--primary);
                &:hover {
                  background-color: var(--primary);
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}

.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  font-size: 18px;
  color: #409eff;
}

.service-inner {
  display: flex;
  align-items: center;
}

.service-inner-image {
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  margin-right: 16px;
}

.service-inner-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.service-inner-info {
  flex: 1;
  overflow: hidden;
}

.service-inner-info h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.service-inner-info p {
  margin: 4px 0 0;
}
</style>
